var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTransactionsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transactions-icon",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M32.167,6.417V5H16.6a1.416,1.416,0,0,0-1,2.418l3.212,3.212L11.3,18.138a1.418,1.418,0,0,0,0,2L13.163,22H3.833V12.67L5.665,14.5a1.418,1.418,0,0,0,2,0l4.25-4.25a1.417,1.417,0,0,0-2-2L6.667,11.5,3.418,8.248A1.416,1.416,0,0,0,1,9.25V24.833H16.583a1.416,1.416,0,0,0,1-2.418l-3.277-3.277,7.508-7.508a1.418,1.418,0,0,0,0-2L20.022,7.833h9.312v9.319l-1.811-1.819a1.416,1.416,0,0,0-2,0l-4.26,4.26a1.417,1.417,0,0,0,2,2l3.258-3.258,3.229,3.244a1.417,1.417,0,0,0,2.417-1V6.417Z",
    transform: "translate(0.417 2.083)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransactionsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transactions-icon.c3865bc5.svg";
export { ForwardRef as ReactComponent };